/**
 * Created by administrator on 2017/3/30.
 */
import NProgress from 'nprogress';
import {
    GetStockOutBySendId
} from '@api/sendGoodsApi.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig,
    ParmConfigDel,
    ParmConfigAdd
} from '@api/commonApi.js';
import {
    ERP_StockOutAdd,
    GetERP_StockOutById,
    ERP_StockOutUpdate
} from '@api/stockOutApi.js';
import $http from '$http';

module.exports = {
    data() {
        return {
            IsUpdate: false,
            Form: {}, //查看内容
            Logistics: [], //物流
            SendGood: "",
            "NumShow": false,
            "visibleShow": false, //物流弹窗
            "dialogContent": "",
            submitFormLoad: false,
            AddForm: {
                "SendId": "", //编号3
                "LogisticsCode": "", //快递单号
                "LogisticsId": "", //快递类型
                "GoodsList": [],
                "GiftsList": [],
                PackageNum: 0,
                "Remark": ""
            },
            picVisible: false,
            picUrl: ""
        }
    },
    methods: {
        getMaxNum(maxNum) {
            let orderType = $.trim(this.Form.OrderType);
            if (orderType.indexOf("SO") > -1 || orderType.indexOf("GK") > -1 || orderType.indexOf("SU") > -1) {
                return Infinity; //ele组件语法规范
            }
            return maxNum;
        },
        viewpic(val) {
            this.picVisible = true;
            this.picUrl = val;
        },
        showDialog() {
            this.visibleShow = true;
        },
        dialogClosed() {
            this.dialogContent = "";
            this.visibleShow = false;
        },
        delLogistics(item) {
            let para = {
                Ids: item.Id
            };
            ParmConfigDel(para).then(res => {
                util.doResult(this, res, () => {
                    this.getLogistics();
                    for (var i = 0; i < this.Logistics.length; i++) {
                        if (this.Logistics[i].Id == item.Id) {
                            this.AddForm.LogisticsId = "";
                        }
                    }
                });
            });
        },
        addLogistics() {
            var para = {
                ParmType: 10,
                ParmName: this.dialogContent
            };
            ParmConfigAdd(para).then(res => {
                util.doResult(this, res, () => {
                    this.getLogistics("1");
                    this.dialogContent = "";
                    this.visibleShow = false;
                });
            });
        },
        SendStatus: function () {
            if (this.SendGood == '全部发货') {
                this.NumShow = true;
                for (var i = 0; i < this.Form.ListGoods.length; i++) {
                    this.Form.ListGoods[i].ActualNum = this.Form.ListGoods[i].Num;
                }
                for (var i = 0; i < this.Form.GiftGoods.length; i++) {
                    this.Form.GiftGoods[i].ActualNum = this.Form.GiftGoods[i].Num;
                }
            } else {
                this.NumShow = false;
            }
        },
        submitForm() {

            this.AddForm.GoodsList = [];
            this.AddForm.GiftsList = [];
            this.AddForm.SendId = this.$route.query.Id;
            this.Form.CurrentSendStatus = this.SendGood;

            if (this.Form.ListGoods.length > 0) {
                for (var i = 0; i < this.Form.ListGoods.length; i++) {
                    var a = {};
                    a.ProId = this.Form.ListGoods[i].ProductId;
                    a.ProNum = this.Form.ListGoods[i].ActualNum;
                    this.AddForm.GoodsList.push(a);
                }
            }

            if (this.Form.GiftGoods.length > 0) {
                for (var i = 0; i < this.Form.GiftGoods.length; i++) {
                    var a = {};
                    a.ProId = this.Form.GiftGoods[i].ProductId;
                    a.ProNum = this.Form.GiftGoods[i].ActualNum;
                    this.AddForm.GiftsList.push(a);
                }
            }

            this.submitFormLoad = true;

            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "包裹件数",
                    value: this.AddForm.PackageNum,
                    required: true,
                    isNumber: true,
                    more0: true
                }]
            });

            if (!flag) {
                return;
            }

            if (this.IsUpdate == true) {
                this.AddForm.StockOutId = this.$route.query.StockOutId;
                this.AddForm.SendId = this.Form.SendId;
                ERP_StockOutUpdate(this.AddForm).then(res => {
                    this.submitFormLoad = false;
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "更新出库单成功",
                            type: 'success'
                        });
                        util.redirect(this, this.getReturnUrl(), false);
                    });
                });
            } else {
                $http.post("api/StockOut/StockOutAddV3", this.AddForm).then(res => {
                    this.loading = false;
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: "成功",
                            message: "生成出库单成功",
                            type: "success"
                        });
                        util.redirect(this, this.getReturnUrl(), false);
                    });
                });
                // ERP_StockOutAdd(this.AddForm).then(res => {
                //     this.submitFormLoad = false;
                //     util.doResult(this, res, () => {
                //         this.$notify({
                //             title: '成功',
                //             message: "生成出库单成功",
                //             type: 'success'
                //         });
                //         //util.redirect(this, "/SendGoods/SendGoodsForStock", false);
                //         //util.redirect(this, "/SendGoods/ViewSendGoodsForStock", false);
                //         util.redirect(this, this.getReturnUrl(), false);
                //     });
                // });
            }

        },
        getLogistics(type) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                ParmType: 10,
            };

            GetParmConfig(para).then(res => {

                util.doResult(this, res, () => {
                    this.Logistics = res.data.Data;
                    if (type == "1") {
                        this.AddForm.LogisticsId = this.Logistics[this.Logistics.length - 1].Id;
                    }
                });
            });
        },
        getReturnUrl() {
            //StockOut/AddStockResources 发货通知（资源包）
            if (this.$route.path == '/StockOut/AddStockResources') {
                return "/SendGoods/SendGoodsForStock";
            }
            //StockOut/AddStockOut 发货通知(仓库)
            return "/SendGoods/SendGoodsStorage";
        }
    },
    created: function () {
        let _session = util.getSessin();
        let a = {
            Sid: _session[0],
            Session: _session[1],
            ParmType: 10,
        };

        GetParmConfig(a).then(res => {
            util.doResult(this, res, () => {
                this.Logistics = res.data.Data;
                if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {
                    let para = {
                        Sid: _session[0],
                        Session: _session[1],
                        SendId: this.$route.query.Id
                    };
                    $http.get('api/SendGoods/GetStockOutBySendId', para).then(res => {
                        util.doResult(this, res, () => {
                            this.Form = res.data.Data;
                        });
                    });
                }

                if (this.$route.query.StockOutId != undefined) {
                    this.IsUpdate = true;
                    let para = {
                        Sid: _session[0],
                        Session: _session[1],
                        Id: this.$route.query.StockOutId
                    };
                    GetERP_StockOutById(para).then(res => {
                        util.doResult(this, res, () => {
                            this.Form = res.data.Data;
                            this.AddForm.LogisticsCode = this.Form.LogisticsCode;
                            this.AddForm.LogisticsId = this.Form.LogisticsId * 1;
                            this.AddForm.Remark = this.Form.Remark;
                            this.SendGood = this.Form.CurrentSendStatus;
                        });
                    })
                }
            });
        });
    },
    computed: {
        isShowIsFirst() {
            if (this.Form.IsFirst > 0) {
                return true;
            }
            return false;
        },
        isShow() {
            if (this.$route.path == '/StockOut/AddStockOut') {
                let orderType = $.trim(this.Form.OrderType);
                if (orderType.indexOf("SC") > -1 || orderType.indexOf("ZS") > -1 || ("110,111,112,113").indexOf(this.Form.PackageId) > -1) {
                    return true;
                }
                return false;
            }
            return true;
        },
        orderTypeShow() {
            let orderType = $.trim(this.Form.OrderType);
            if (orderType.indexOf("SO") > -1 || orderType.indexOf("GK") > -1 || orderType.indexOf("SU") > -1) {
                return true;
            }
            return false;
        },
        isShowGK() {
            let orderType = $.trim(this.Form.OrderType);
            if (orderType.indexOf("GK") > -1) {
                return true;
            }
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/StockOut/AddStockOutControl.js